<template>
  <a-table
    :columns="columns"
    :data-source="list"
    bordered
    rowKey="id"
    :pagination="false"
    :loading="loading"
    size="small"
  >
    <!-- 类型 -->
    <template slot="updateType" slot-scope="text">
      <span v-for="item in $t('com_operationTypes')" :key="item.value">
        <span v-if="text === item.value">{{ item.name }}</span>
      </span>
    </template>

    <template slot="stationName" slot-scope="text">
      <div class="g-table-text">
        {{ text }}
      </div>
    </template>

    <!-- 执行数据 -->
    <template slot="executeData" slot-scope="text, record">
      <div class="g-table-text">
        <a-icon
          type="copy"
          data-clipboard-action="copy"
          title="Copy"
          style="color:#ccc"
          :data-clipboard-text="`${text}`"
          :id="`logs_site_event_${record.id}`"
          @click="copyContent(`#logs_site_event_${record.id}`)"
        />{{ text }}
      </div>
    </template>

    <!-- 时间 -->
    <template slot="executeTime" slot-scope="text">
      {{ text | formatDate }}
    </template>

    <!-- 属地 -->
    <template slot="Location" slot-scope="text">
      {{ text | location }}
    </template>
  </a-table>
</template>
<script>
import { copyContent } from '@/libs/utils';

export default {
  props: {
    list: {
      type: [Array, Object],
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      copyContent,
      columns: [
        {
          title: this.$t('com_table_id'),
          align: 'center',
          dataIndex: 'id',
        },
        {
          title: this.$t('logs_table_site_name'),
          dataIndex: 'stationName',
          scopedSlots: { customRender: 'stationName' },
        },

        {
          title: this.$t('logs_table_data'),
          dataIndex: 'executeData',
          scopedSlots: { customRender: 'executeData' },
        },

        {
          title: this.$t('logs_table_user'),
          dataIndex: 'executeUserName',
          align: 'center',
        },

        {
          title: this.$t('logs_table_ip'),
          dataIndex: 'hostIp',
          align: 'center',
        },

        {
          title: this.$t('logs_table_location'),
          dataIndex: 'location',
          align: 'center',
          scopedSlots: { customRender: 'Location' },
        },

        {
          title: this.$t('com_table_type'),
          dataIndex: 'updateType',
          scopedSlots: { customRender: 'updateType' },
        },

        {
          title: this.$t('logs_table_execute_time'),
          dataIndex: 'executeTime',
          scopedSlots: { customRender: 'executeTime' },
        },
      ],
    };
  },
};
</script>
